<div class="page-layout simple fullwidth">
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <h2>{{ "CATALOGUE.CAT" | translate | uppercase }}</h2>
    </div>
    <div class="center p-24 pb-56" fusePerfectScrollbar>
        <div class="content">
            <div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
                <mat-tab-group
                    dynamicHeight="true"
                    (selectedTabChange)="limpiarTabla($event)"
                >
                    <mat-tab
                        *ngFor="let catalogo of catalogos"
                        [label]="catalogo.descripcion"
                    >
                        <div class="p-24">
                            <app-lista-grupos-catalogo
                                [grupos]="catalogo.grupos"
                                (idGrupoEmitter)="buscaServicios($event)"
                            ></app-lista-grupos-catalogo>
                            <app-tabla-servicios
                                [servicio]="servicio"
                                [atributos]="catalogo.atributos"
                                (refrescarTablaEmitter)="refrescarTabla()"
                            ></app-tabla-servicios>
                        </div>

                        <button
                            mat-fab
                            class="accent"
                            id="agregar-cliente-button"
                            (click)="nuevoServicio(catalogo)"
                            aria-label="Nuevo Servicio"
                            [@animate]="{
                                value: '*',
                                params: { delay: '300ms', scale: '.2' }
                            }"
                        >
                            <mat-icon>add</mat-icon>
                        </button>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
</div>
